import Component from '@bythepixel/component-loader';
import { Swiper, Navigation, Thumbs } from 'swiper';
import 'swiper/swiper-bundle.min.css';

export default class Lightbox extends Component {
  static selector = '[comp-lightbox]'
  #lightboxId
  #galleryThumbs
  #galleryTop
  #state = {
    initialized: false,
  }

  constructor(...args) {
    super(...args);
    this.events();

    this.galleryThumbsContainer = this.$container.querySelector('[comp-lightbox-thumbs]');
    this.galleryTopContainer = this.$container.querySelector('[comp-lightbox-view]');

    this.#lightboxId = this.$container.getAttribute('comp-lightbox');
    this.#state.initialized = false;

    Swiper.use([Thumbs, Navigation]);
  }

  events() {
    this.$subscribe('lightbox:open', ({ lightboxSlide, lightboxId }) => {
      if (lightboxId !== this.#lightboxId) return;
      this.openLightbox(lightboxSlide);
    });
    this.$subscribe('lightbox:close', () => {
      this.closeLightbox();
    });
  }

  openLightbox(showSlideIndex) {
    this.$container.classList.remove('hidden');

    if (!this.#state.initialized) {
      this.initializeSliders();
    }
    this.#galleryTop.slideTo(Number(showSlideIndex));
    this.#state.initialized = true;
  }

  closeLightbox() {
    this.$container.classList.add('hidden');
  }

  initializeSliders() {
    this.#galleryThumbs = new Swiper(this.galleryThumbsContainer, {
      slidesPerView: 'auto',
      freeMode: true,
      centeredSlides: true,
      // cssMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    this.#galleryTop = new Swiper(this.galleryTopContainer, {
      spaceBetween: 128,
      slidesPerView: 1.2,
      centeredSlides: true,
      navigation: {
        nextEl: '.lightbox-btn.lightbox-btn--next',
        prevEl: '.lightbox-btn.lightbox-btn--prev',
      },
      thumbs: {
        swiper: this.#galleryThumbs,
      },
    });
  }
}
